import React, { useState } from "react"

const inputs = [
	{ type: "text", label: "First Name", placeholder: "John" },
	{ type: "text", label: "Last Name", placeholder: "Smith" },
	{ type: "email", label: "Email", placeholder: "name@website.com.au" },
	{ type: "text", label: "Job Title", placeholder: "Filmmaker" },
	{ type: "text", label: "Company", placeholder: "Acme Corporation" },
	{ type: "select", label: "Area of Interest (optional)", options: ["Project Enquiry", "General Enquiry"] },
]

const ContactForm = () => (
	<div className='p40 m-p0 text-center'>
		<div className=''>
			<Form className=''>
				{inputs.map(input => {
					if (input.type === "select") return <Select key={input.label} input={input} />
					return (
						<fieldset className='input--wrapper br1 m-br0' key={input.label}>
							<label htmlFor={input.label} className='op-50'>
								{input.label}
							</label>
							<input required type={input.type} name={input.label} className='input' placeholder={input.placeholder} />
						</fieldset>
					)
				})}
				<button type='submit' value='Submit' className='w-50 col-span-2 pointer button'>
					Submit
				</button>
			</Form>
		</div>
	</div>
)

export default ContactForm

const Select = ({ input }) => (
	<fieldset className='input--wrapper'>
		<label htmlFor={input.label} className='op-50 '>
			{input.label}
		</label>
		<div className='pos-rel'>
			<select name={input.label} defaultValue={"pleaseSelect"} className=' w-100 input'>
				<option disabled value='pleaseSelect'>
					Please Select
				</option>
				{input.options.map((option, index) => (
					<option key={index} value={option}>
						{option}
					</option>
				))}
			</select>
			<div className='chevron' />
		</div>
	</fieldset>
)

const Form = ({ children, className = "", name = "contact" }) => {
	const [isFormSubmitted, setIsFormSubmitted] = useState(false)

	const handleSubmit = event => {
		event.preventDefault()
		const myForm = event.target
		const formData = new FormData(myForm)
		// send email to sales with form info
		fetch("https://2ki366u2x7yyrvvcqcji7ufcwq0offjr.lambda-url.us-east-1.on.aws/", {
			method: "POST",
			body: new URLSearchParams(formData).toString(),
			isBase64Encoded: false,
		})
			.then(() => {
				setIsFormSubmitted(true)
			})
			.catch(error => alert(error))
	}

	const handleSubmissionClose = e => {
		e.preventDefault()
		setIsFormSubmitted(false)
		const form = document.querySelector(".form")
		form.reset()
	}

	return (
		<form method='POST' onSubmit={e => handleSubmit(e)} data-netlify='true' name={name} netlify-honeypot='bot-field' className={"form pos-rel " + className}>
			<input type='hidden' name='bot-field' />
			<input type='hidden' name='form-name' value={name} />
			<div className={`form-items grid grid-2 gap-20 m-gap ${isFormSubmitted && "op-0"}`}>{children}</div>
			<div className={`form-submission-message z-2 ${isFormSubmitted ? " op-100 pointer-auto" : " op-0 pointer-none"}`}>
				<h4 className='m0 max-450 ma mt40 '>Thank you for submitting the form we'll be in touch soon</h4>
				<button onClick={e => handleSubmissionClose(e)} className='submission-close mt40 pointer p20 w-50'>
					← Go Back
				</button>
			</div>
		</form>
	)
}
